import { createFileRoute, Outlet } from '@tanstack/react-router'
import { supplierQueryOptions } from '../../../../features/suppliers/queries'

export const Route = createFileRoute('/_app/suppliers/$supplierId')({
  staticData: { crumb: 'supplier' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(supplierQueryOptions(params.supplierId)),
  component: Outlet,
})
